import { useState, useEffect } from 'react'
import { cssClassManager } from '../services/CSSClassManager'

/**
 * React hook for the centralized CSS Class Manager
 * All components should use this instead of local state
 */
export const useCSSClassManager = () => {
  const [classes, setClasses] = useState([])

  useEffect(() => {
    // Subscribe to changes
    const unsubscribe = cssClassManager.subscribe((updatedClasses) => {
      setClasses(updatedClasses)
    })

    // Initialize with current classes
    setClasses(cssClassManager.getAllClasses())

    return unsubscribe
  }, [])

  return {
    // Data
    classes,
    isInitialized: cssClassManager.isInitialized,

    // Methods
    initialize: (classesData) => cssClassManager.initialize(classesData),
    getClass: (className) => cssClassManager.getClass(className),
    createClass: (className, properties, skipDefaults) => cssClassManager.createClass(className, properties, skipDefaults),
    updateClass: (className, properties) => cssClassManager.updateClass(className, properties),
    updateProperty: (className, property, value) => cssClassManager.updateProperty(className, property, value),
    renameClass: (oldName, newName, properties) => cssClassManager.renameClass(oldName, newName, properties),
    deleteClass: (className) => cssClassManager.deleteClass(className),
    upsertClass: (className, properties, skipDefaults) => cssClassManager.upsertClass(className, properties, skipDefaults),
  }
}